import React from "react";
import { XMarkIcon, BuildingOfficeIcon, ArrowPathIcon } from "@heroicons/react/24/outline";

const RenewalModal = ({
  show,
  renewalCustomer,
  onClose,
  renewalFormData,
  setRenewalFormData,
  employeeConfig,
  handleRenewal,
  loading,
  DatePicker,
  setRenewalCustomer
}) => {
  if (!show || !renewalCustomer) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-2 sm:px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={() => {
          onClose();
          setRenewalCustomer(null);
        }}></div>

        <div className="inline-block align-bottom bg-white dark:bg-gray-900 rounded-lg text-left overflow-visible shadow-xl transform transition-all my-4 sm:my-8 sm:align-middle w-full max-w-xs sm:max-w-lg md:max-w-xl max-h-[90vh] overflow-y-auto">
          <div className="px-3 sm:px-6 pt-5 pb-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">Renew Subscription</h3>
              <button
                onClick={() => {
                  onClose();
                  setRenewalCustomer(null);
                }}
                className="hover:opacity-80"
              >
                <XMarkIcon className="w-6 h-6 text-gray-500 dark:text-gray-400" />
              </button>
            </div>

            <div className="mb-4 p-4 rounded-lg bg-blue-500">
              <div className="flex items-center space-x-2 mb-2">
                <BuildingOfficeIcon className="w-5 h-5 text-white" />
                <p className="font-semibold text-white">{renewalCustomer.company}</p>
              </div>
              <p className="text-sm text-white">
                <span className="font-medium">Customer:</span> {renewalCustomer.firstname} {renewalCustomer.lastname}
              </p>
              <p className="text-sm text-white">
                <span className="font-medium">Current Renewal Date:</span> {new Date(renewalCustomer.renewal_date).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
              <p className="text-sm text-green-300 mt-2">
                <span className="font-medium">New Renewal Date:</span> {new Date(new Date(renewalCustomer.renewal_date).setFullYear(new Date(renewalCustomer.renewal_date).getFullYear() + 1)).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            </div>

            <form onSubmit={handleRenewal} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  Employee Count Range *
                </label>
                <select
                  required
                  value={renewalFormData.employeecount}
                  onChange={(e) => {
                    const selectedRange = e.target.value;
                    const selectedConfig = employeeConfig.find(config => config.name === selectedRange);
                    setRenewalFormData({
                      ...renewalFormData,
                      employeecount: selectedRange,
                      price: selectedConfig ? selectedConfig.value : renewalFormData.price
                    });
                  }}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-gray-100"
                >
                  <option value="">Select employee count</option>
                  {employeeConfig && employeeConfig.length > 0 ? (
                    employeeConfig.map((config) => (
                      <option key={config._id || config.id} value={config.name}>
                        {config.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>Loading employee ranges...</option>
                  )}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">
                  Price (USD) *
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-2 text-gray-500 dark:text-gray-400">$</span>
                  <input
                    type="number"
                    required
                    min="0"
                    step="0.01"
                    value={renewalFormData.price}
                    onChange={(e) => setRenewalFormData({...renewalFormData, price: e.target.value})}
                    className="w-full pl-8 pr-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 dark:border-gray-600"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div>
                <DatePicker
                  value={renewalFormData.renewal_date || ""}
                  onChange={(date) => setRenewalFormData({...renewalFormData, renewal_date: date})}
                  label="New Renewal Date"
                  helperText="Select the new subscription renewal date"
                />
              </div>

              <div className="flex justify-end space-x-3 pt-4 border-t dark:border-gray-700">
                <button
                  type="button"
                  onClick={() => {
                    onClose();
                    setRenewalCustomer(null);
                  }}
                  className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
                >
                  <ArrowPathIcon className="w-4 h-4" />
                  <span>{loading ? 'Processing...' : 'Renew Subscription'}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewalModal;
